module.exports = __webpack_public_path__ + "assets/img/contractors.48c44d6e.svg";